<template>
  <div class="news-tree">
    <!-- 树 -->
    <div class="menu-tree" v-if="secondLevelList.length > 0">
      <div
        v-for="(item, index) in secondLevelList"
        :key="item.menuId"
        class="menu-group"
      >
        <!-- 二级标题 -->
        <div
          :class="['tab-item', { active: activeSecond === index }]"
          @click="handleSecondClick(index, item)"
        >
          <span class="tab-label">{{ item.menuName }}</span>
          <span
            v-if="getThirdLevelList(item).length > 0"
            :class="['arrow', { expanded: isExpanded(item.menuId) }]"
            @click.stop="toggleExpand(item.menuId)"
          >
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 6 15 12 9 18"></polyline>
            </svg>
          </span>
        </div>
        <!-- 三级子级（展开时显示） -->
        <transition name="slide-down">
          <div
            class="third-list"
            v-show="isExpanded(item.menuId) && getThirdLevelList(item).length > 0"
          >
            <div
              v-for="(sub, subIndex) in getThirdLevelList(item)"
              :key="sub.menuId"
            >
              <div
                :class="['third-item', { active: activeSecond === index && activeThird === subIndex && activeFourth === -1 }]"
                @click.stop="handleThirdClick(index, subIndex, sub)"
              >
                <span class="tab-label">{{ sub.menuName }}</span>
                <span
                  v-if="getFourthLevelList(sub).length > 0"
                  :class="['arrow-small', { expanded: isExpanded(sub.menuId) }]"
                  @click.stop="toggleExpand(sub.menuId)"
                >
                  <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 6 15 12 9 18"></polyline>
                  </svg>
                </span>
              </div>
              <!-- 四级子级（展开时显示） -->
              <transition name="slide-down">
                <div
                  class="fourth-list"
                  v-show="isExpanded(sub.menuId) && getFourthLevelList(sub).length > 0"
                >
                  <div
                    v-for="(sub4, sub4Index) in getFourthLevelList(sub)"
                    :key="sub4.menuId"
                    :class="['fourth-item', { active: activeSecond === index && activeThird === subIndex && activeFourth === sub4Index }]"
                    @click.stop="handleFourthClick(index, subIndex, sub4Index, sub4)"
                  >
                    {{ sub4.menuName }}
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div v-else class="empty-tip sidebar-tip">暂无数据</div>
  </div>
</template>

<script>
export default {
  name: 'NewsTree',
  props: {
    // 二级分类数组（每个元素含 menuId / menuName / children）
    secondLevelList: {
      type: Array,
      default: () => []
    },
    // 一级标题 { cn, en }
    firstTitle: {
      type: Object,
      default: () => ({ cn: '新闻中心', en: 'NEWS CENTER' })
    }
  },
  data() {
    return {
      // -1 表示未选中
      activeSecond: -1,
      activeThird: -1,
      activeFourth: -1,
      // 栏目展开状态（menuId -> boolean）
      expandedMap: {}
    }
  },
  watch: {
    // 数据变化时重置状态：默认展开第一个
    secondLevelList: {
      immediate: true,
      handler(newList) {
        if (newList && newList.length > 0) {
          this.activeSecond = -1
          this.activeThird = -1
          this.activeFourth = -1
          this.expandedMap = {}
          this.$set(this.expandedMap, newList[0].menuId, true)
        }
      }
    }
  },
  methods: {
    // 过滤三级子级（只显示 M 类型目录）
    getThirdLevelList(secondItem) {
      if (!secondItem || !secondItem.children) return []
      return secondItem.children.filter(c => c.menuType === 'M')
    },
    // 过滤四级子级（只显示 M 类型目录）
    getFourthLevelList(thirdItem) {
      if (!thirdItem || !thirdItem.children) return []
      return thirdItem.children.filter(c => c.menuType === 'M')
    },
    isExpanded(menuId) {
      return !!this.expandedMap[menuId]
    },
    toggleExpand(menuId) {
      this.$set(this.expandedMap, menuId, !this.expandedMap[menuId])
    },
    // 点击二级：再次点击已选中的项目则取消选中（emit null）
    handleSecondClick(index, item) {
      if (this.activeSecond === index) {
        this.activeSecond = -1
        this.activeThird = -1
        this.activeFourth = -1
        this.$emit('select', null)
      } else {
        this.activeSecond = index
        this.activeThird = -1
        this.activeFourth = -1
        this.$set(this.expandedMap, item.menuId, true)
        this.$emit('select', item)
      }
    },
    // 点击三级：再次点击已选中的项目则取消选中（emit 父级二级节点）
    handleThirdClick(secondIndex, thirdIndex, item) {
      if (
        this.activeSecond === secondIndex &&
        this.activeThird === thirdIndex &&
        this.activeFourth === -1
      ) {
        this.activeThird = -1
        this.$emit('select', this.secondLevelList[secondIndex])
      } else {
        this.activeSecond = secondIndex
        this.activeThird = thirdIndex
        this.activeFourth = -1
        this.$set(this.expandedMap, item.menuId, true)
        // 父级二级也保持展开
        this.$set(
          this.expandedMap,
          this.secondLevelList[secondIndex].menuId,
          true
        )
        this.$emit('select', item)
      }
    },
    // 点击四级：再次点击已选中的项目则取消选中（emit 父级三级节点）
    handleFourthClick(secondIndex, thirdIndex, fourthIndex, item) {
      if (
        this.activeSecond === secondIndex &&
        this.activeThird === thirdIndex &&
        this.activeFourth === fourthIndex
      ) {
        this.activeFourth = -1
        // 回退到父级三级节点
        const thirdList = this.getThirdLevelList(this.secondLevelList[secondIndex])
        this.$emit('select', thirdList[thirdIndex])
      } else {
        this.activeSecond = secondIndex
        this.activeThird = thirdIndex
        this.activeFourth = fourthIndex
        // 展开当前四级
        this.$set(this.expandedMap, item.menuId, true)
        // 保持父级三级展开
        const thirdList = this.getThirdLevelList(this.secondLevelList[secondIndex])
        this.$set(this.expandedMap, thirdList[thirdIndex].menuId, true)
        // 保持父级二级展开
        this.$set(
          this.expandedMap,
          this.secondLevelList[secondIndex].menuId,
          true
        )
        this.$emit('select', item)
      }
    }
  }
}
</script>

<style scoped>
.news-tree {
  width: 380px;
  min-width: 280px;
  margin-right: 40px;
  border-right: 1px solid #e0e0e0;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
}



/* 菜单树 - 固定高度 + 滚动 */
.menu-tree {
  display: flex;
  flex-direction: column;
  height: 600px;
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  margin-top: 20px;
}

.menu-tree::-webkit-scrollbar {
  width: 6px;
}

.menu-tree::-webkit-scrollbar-thumb {
  background: #d4d4d4;
  border-radius: 3px;
}

.menu-tree::-webkit-scrollbar-thumb:hover {
  background: #008d40;
}

.menu-group {
  margin-bottom: 0;
}

/* 二级标题 tab */
.tab-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;
  font-size: 17px;
  font-weight: 500;
  color: #555;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 12px;
  transition: all 0.25s ease;
  background: #fafafa;
  text-align: left;
  line-height: 1.4;
  gap: 8px;
}

.tab-label {
  flex: 1;
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.5;
}

.arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 50%;
  background: #f0f0f0;
  color: #888;
  transition: transform 0.25s ease, background 0.2s ease, color 0.2s ease;
  transform: rotate(0deg);
  margin-left: 6px;
}

.arrow svg {
  display: block;
  width: 14px;
  height: 14px;
}

.arrow:hover {
  background: #e0f4e9;
  color: #008d40;
}

.arrow.expanded {
  transform: rotate(90deg);
  background: #e0f4e9;
  color: #008d40;
}

.tab-item:hover {
  color: #008d40;
  border-color: #008d40;
  background: #f0fdf4;
}

.tab-item.active {
  color: #fff;
  background: #008d40;
  border-color: #008d40;
  font-weight: 600;
}

.tab-item.active .arrow {
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
}

.tab-item.active .arrow:hover {
  background: rgba(255, 255, 255, 0.4);
  color: #fff;
}

/* 三级展开/收起过渡 */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: max-height 0.25s ease, opacity 0.2s ease;
  overflow: hidden;
}

.slide-down-enter,
.slide-down-leave-to {
  max-height: 0;
  opacity: 0;
}

.slide-down-enter-to,
.slide-down-leave {
  max-height: 500px;
  opacity: 1;
}

/* 三级标题列表 */
.third-list {
  display: flex;
  flex-direction: column;
  padding-left: 12px;
  margin-top: 2px;
  margin-bottom: 4px;
  border-left: 2px solid #ececec;
  margin-left: 14px;
}

.third-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 2px 10px 6px 20px;
  cursor: pointer;
  font-size: 17px;
  color: #666;
  border: 1px solid transparent;
  border-radius: 3px;
  margin-bottom: 2px;
  transition: all 0.2s ease;
  position: relative;
  line-height: 1.3;
  gap: 6px;
}

.third-item::before {
  content: '';
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #ccc;
  transition: all 0.2s ease;
}

.third-item:hover {
  color: #008d40;
  background: #f9f9f9;
}

.third-item:hover::before {
  background-color: #008d40;
}

.third-item.active {
  color: #008d40;
  font-weight: 600;
  background: #f0fdf4;
}

.third-item.active::before {
  background-color: #008d40;
  width: 6px;
  height: 6px;
}

/* 三级上的小箭头 */
.arrow-small {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 50%;
  background: #f0f0f0;
  color: #888;
  transition: transform 0.25s ease, background 0.2s ease, color 0.2s ease;
  transform: rotate(0deg);
  margin-left: 4px;
}

.arrow-small svg {
  display: block;
  width: 12px;
  height: 12px;
}

.arrow-small:hover {
  background: #e0f4e9;
  color: #008d40;
}

.arrow-small.expanded {
  transform: rotate(90deg);
  background: #e0f4e9;
  color: #008d40;
}

/* 四级标题列表 */
.fourth-list {
  display: flex;
  flex-direction: column;
  padding-left: 12px;
  margin-top: 2px;
  margin-bottom: 4px;
  border-left: 2px solid #ececec;
  margin-left: 14px;
}

.fourth-item {
  padding: 2px 10px 6px 20px;
  cursor: pointer;
  font-size: 16px;
  color: #777;
  border: 1px solid transparent;
  border-radius: 3px;
  margin-bottom: 2px;
  transition: all 0.2s ease;
  position: relative;
  line-height: 1.3;
}

.fourth-item::before {
  content: '';
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #ccc;
  transition: all 0.2s ease;
}

.fourth-item:hover {
  color: #008d40;
  background: #f9f9f9;
}

.fourth-item:hover::before {
  background-color: #008d40;
}

.fourth-item.active {
  color: #008d40;
  font-weight: 600;
  background: #f0fdf4;
}

.fourth-item.active::before {
  background-color: #008d40;
  width: 6px;
  height: 6px;
}

.empty-tip {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #bbb;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 1px;
  padding: 0;
}

.sidebar-tip {
  padding-top: 0;
  text-align: center;
}

/* 响应式适配 */
@media screen and (max-width: 768px) {
  .news-tree {
    width: 100%;
    min-width: unset;
    margin-right: 0;
    border-right: none;
    border-bottom: 1px solid #e0e0e0;
    padding-right: 0;
    padding-bottom: 20px;
  }

  .tab-item {
    margin-bottom: 8px;
    font-size: 17px;
    padding: 12px 14px;
  }

  .third-list {
    padding-left: 12px;
    margin-left: 6px;
  }

  .third-item {
    margin-bottom: 4px;
    font-size: 13px;
    padding: 8px 10px 8px 20px;
  }

  .fourth-list {
    padding-left: 12px;
    margin-left: 6px;
  }

  .fourth-item {
    margin-bottom: 4px;
    font-size: 13px;
    padding: 8px 10px 8px 20px;
  }
}
</style>
